import React from 'react';
import { legendTicks } from './hexMapStyles';

// Plain markup — gradient/tick strip for quant/diverging metrics, three
// swatches for the status metric. No `src/ui` primitives (see the
// Select/MenuItem import comment in PmlSnapshotPage.jsx for this page's one
// exception to that rule).
const MapLegend = ({ metric, peak }) => {
  const ticks = legendTicks(metric, peak);
  const isStatus = metric === 'status';

  return (
    <div style={S.wrap} data-testid="map-legend">
      {isStatus ? (
        <div style={S.swatchRow}>
          {ticks.map((t) => (
            <div key={t.value} style={S.swatchItem}>
              <span style={{ ...S.swatch, background: t.color }} />
              <span style={S.tickLabel}>{t.label}</span>
            </div>
          ))}
        </div>
      ) : (
        <div style={S.gradientRow}>
          {ticks.map((t) => (
            <div key={t.value} style={S.tick}>
              <span style={{ ...S.chip, background: t.color }} />
              <span style={S.tickLabel}>{t.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const S = {
  wrap: { display: 'flex', alignItems: 'center', fontSize: 11, color: '#637381' },
  gradientRow: { display: 'flex', alignItems: 'center', gap: 12 },
  tick: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 },
  chip: { display: 'block', width: 16, height: 8, borderRadius: 2 },
  swatchRow: { display: 'flex', alignItems: 'center', gap: 12 },
  swatchItem: { display: 'flex', alignItems: 'center', gap: 4 },
  swatch: { display: 'block', width: 10, height: 10, borderRadius: '50%' },
  tickLabel: { whiteSpace: 'nowrap' },
};

export default MapLegend;
